// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2x9Px","rootSuccess":"CompleteLink_rootSuccess__2nn_6","rootFailure":"CompleteLink_rootFailure__2jsbA","isDisabled":"CompleteLink_isDisabled__25qcF"};